import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { EntityApiClientFactory } from 'mm-web-core/http/enitty-api-client-factory';
import { tap, throwIfEmpty } from 'rxjs/operators';
import { MmIdentityService } from './services/identity-service';

@Pipe({
  name: 'userDisplayName',
  pure: false
})
export class UserDisplayNamePipe implements PipeTransform {

  constructor(private api: MmIdentityService, private cdr: ChangeDetectorRef) {
  }


  displayName: string = '';
  value: string | string[];
  transform(value: string | string[], ...args: unknown[]): string {
    if (!value) {
      this.value = value;
      this.displayName = ''
      return this.displayName;
    }
    let ids: string[];
    if (typeof value === "string") {
      ids = [value];
    }
    else if (Array.isArray(value)) {
      ids = [...value];
    }
    if (this.value !== value) {
      this.value = value;
      this.api.getUserDisplayNames(ids).subscribe(result => {
        this.displayName = Object.keys(result).map(key => result[key]).join(",");

        this.cdr.markForCheck();
      });
    }

    return this.displayName;
  }

}
